import React from "react";
import { IonContent, IonPage, IonImg } from "@ionic/react";
import "./Privacy.css";

const Privacy: React.FC = () => {
  return (
    <IonPage>
      <IonContent>
        <div className="privacy-outer">
          <div className="privacy-inner">
            <IonImg
              className="privacy-image"
              src={require("../assets/images/SnappyXO_logo.png")}
            />
            <div className="privacy-textarea">
              <h3>Privacy Policy</h3>
              <p>
                Mechanismic Inc. built the SnappyXOProjects app as a free app.
                This application is provided at no cost and is intended to use
                as is.
              </p>
              <p>The app does not collect any information from users.</p>
              <p>
                We may update our Privacy Policy as needed as we may start
                collecting data related to crashes in the future. Thus, you are
                advised to review this page periodically for any changes. We
                will notify you of any changes by posting the new Privacy Policy
                on this page. These changes are effective immediately after they
                are posted on this page.
              </p>
            </div>
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default React.memo(Privacy);
